// Web Push: cada aparelho da equipe ativa uma vez pelo painel; o aviso de nova
// solicitação é enviado pelo servidor (Web Push/VAPID). Nenhuma chave privada aqui.
const API = process.env.REACT_APP_BACKEND_URL;

const staffUser = () => JSON.parse(localStorage.getItem('hud_admin_user') || 'null');

const b64ToUint8 = (value) => {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
};

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export async function pushState() {
  if (!pushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return sub ? 'enabled' : 'disabled';
}

// Deve ser chamada a partir de um clique (exigência dos navegadores, sobretudo iOS).
export async function enablePush() {
  const reg = await navigator.serviceWorker.ready;
  const res = await fetch(`${API}/api/push/public-key`);
  if (!res.ok) throw new Error('Notificações não configuradas no servidor.');
  const { publicKey } = await res.json();
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(publicKey) });
  const me = staffUser();
  const save = await fetch(`${API}/api/push/subscriptions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Admin-Role': me?.role || '' },
    body: JSON.stringify({ userId: me?.id || '', subscription: sub.toJSON() }),
  });
  if (!save.ok) throw new Error('Falha ao registrar este aparelho.');
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  const me = staffUser();
  await fetch(`${API}/api/push/subscriptions`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', 'X-Admin-Role': me?.role || '' },
    body: JSON.stringify({ endpoint: sub.endpoint }),
  });
  await sub.unsubscribe();
}
